import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GeneralAlert from "../../components/common/GeneralAlert";
import { Version } from "../../types/version";
import useVersionLogic from "../../hooks/logic/versionLogic";

interface VersionPageWrapperProps {
  Component: React.FC<{
    systemLanguageType: Version["system_language_type"];
  }>;
}

const VersionPageWrapper: React.FC<VersionPageWrapperProps> = ({ Component }) => {
  const navigate = useNavigate();
  const { system_language_type } = useParams<{
    system_language_type?: string;
  }>();
  const { systemLanguageType } = useVersionLogic(system_language_type);

  if (!systemLanguageType) {
    return (
      <GeneralAlert
        errorMessage="Invalid system language type"
        action={() => navigate(-1)}
        actionLabel="Go Back"
      />
    );
  }

  return <Component systemLanguageType={systemLanguageType} />;
};

export default VersionPageWrapper;
